import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import { moneyTransferApi } from 'src/Services/API';
import { trackFundCallLineSettled } from 'src/Services/Mixpanel/events';
import { CreateMoneyTransferDto } from 'src/types/money-transfer.types';

interface Options {
  onSuccess?: () => void;
}

export const useCreateMoneyTransfer = (options?: Options) => {
  const { assetId } = useParams<{ assetId: string }>();
  const queryClient = useQueryClient();

  return useMutation(
    (data: CreateMoneyTransferDto) => {
      if (!assetId) throw new Error('Asset ID is missing');
      return moneyTransferApi.create(assetId, data);
    },
    {
      onSuccess: (_transfer, data) => {
        queryClient.invalidateQueries(['money-transfers', assetId]);
        queryClient.invalidateQueries(['expenses', assetId]); // Balance might change
        queryClient.invalidateQueries(['fetch-expenses', assetId]); // Refresh expense list (reimbursement status)
        queryClient.invalidateQueries(['fetch-expense-balance', assetId]);
        queryClient.invalidateQueries(['fetch-personal-wallet', assetId]);
        queryClient.invalidateQueries(['asset-stats', assetId]);
        if (data.fundCallLineId) {
          // The API moved the line to paid: without this the list kept « 0/2 versés ».
          queryClient.invalidateQueries(['fund-calls', assetId]);
          trackFundCallLineSettled({ amount: data.amount });
        }
        options?.onSuccess?.();
      },
    }
  );
};
